import { AuthorizationLevel } from "types/http";
import { HttpService } from "services";
import { SetVendorZipcodesFunction } from "types/functions";
import { ApiUser } from "types/api";
import { generateQueryString } from "utils";

/**
 * Set new zipcodes set for a Vendor.
 * 
 * As of now this endpoint returns only one Vendors in an array.
 *
 * @NOTE: In future add support for multiple Vendors.
 * 
 * @throws {UserServiceException}
 */
export const setZipcodes: SetVendorZipcodesFunction = async (
  ...args: Parameters<SetVendorZipcodesFunction>
) => {
  const [vendorId, zipcodes] = args;
  try {
    const response = await HttpService.fetch<ApiUser[]>(
      `/vendor-zipcode${generateQueryString({ vendorId })}`,
      {
        requestConfig: {
          method: "PUT",
          data: {
            zipcodes: zipcodes.map((zipcode) => zipcode.toString()),
          },
        },
      },
      AuthorizationLevel.AUTHORIZED
    );

    return response.map((user) => HttpService.Serializer.serializeUser(user));
  } catch (error) {
    throw error;
  }
};
